var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _tspan, _path, _rect6, _g, _rect7, _tspan2, _tspan3, _tspan4, _rect8, _tspan5, _rect9, _rect10, _tspan6, _rect11, _rect12, _tspan7, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _tspan8, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyForms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 300,
    viewBox: "0 0 132.29 79.375",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "ArrowWide",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 .125 0)",
    d: "m3-3-3 3 3 3",
    fill: "none",
    stroke: "context-stroke"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ArrowWide-9",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 .125 0)",
    d: "m3-3-3 3 3 3",
    fill: "none",
    stroke: "context-stroke"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ArrowWide-9-6",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 .125 0)",
    d: "m3-3-3 3 3 3",
    fill: "none",
    stroke: "context-stroke"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.27554
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.75656 0 0 .65608 -11.569 3.2334)",
    fill: "#ff8c00"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 91.28,
    y: 2.3776,
    width: 38.635,
    height: 40.472,
    rx: 1.3989,
    ry: 1.6131,
    fillOpacity: 0.1,
    stroke: "#ff8c00",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.27554
  })), /*#__PURE__*/React.createElement("g", null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1.0355 0 0 1.1941 -1.9043 -3.8478)",
    x: 91.782,
    y: 33.503,
    width: 30.087,
    height: 3.175,
    rx: 2.0264,
    ry: 2.0264
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1.0355 0 0 1.1941 -1.9043 -3.8478)",
    x: 91.782,
    y: 28.137,
    width: 30.087,
    height: 3.175,
    rx: 2.0264,
    ry: 2.0264
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1.0355 0 0 1.1941 -1.9043 -3.8478)",
    x: 91.782,
    y: 22.771,
    width: 30.087,
    height: 3.175,
    rx: 2.0264,
    ry: 2.0264
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1.0355 0 0 1.1941 -1.9043 -3.8478)",
    x: 91.782,
    y: 17.404,
    width: 30.087,
    height: 3.175,
    rx: 2.0264,
    ry: 2.0264
  })), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.93123 1.0738)",
    x: 108.26129,
    y: 11.991571,
    fontFamily: "Jamrul",
    fontSize: "6.7598px",
    strokeDasharray: "0.294209, 0.588419, 0.294209, 1.17683",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.29421,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 108.26129,
    y: 11.991571,
    fill: "#ff8c00",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "6.7598px",
    strokeWidth: 0.29421
  }, "SBC Inc."))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m96.42 7.9897-0.51885-0.14581-0.91594 0.67762v4.115h-0.82269v-0.6728c0.02561 0.0066 0.05223 0.0099 0.07952 0.0099 0.20078 0 0.36338-0.18743 0.36338-0.41885 0-0.12881-0.05041-0.24411-0.12979-0.32096 0.07934-0.07685 0.12979-0.19215 0.12979-0.32095 0-0.19698-0.11784-0.36206-0.27671-0.40694-0.02535-0.15831-0.14565-0.27825-0.29018-0.27825-0.14462 0-0.26502 0.11994-0.29018 0.27814-0.15887 0.04488-0.27687 0.20997-0.27687 0.40706 0 0.12881 0.05041 0.24411 0.12985 0.32095-0.07943 0.07685-0.12985 0.19216-0.12985 0.32096 0 0.23142 0.1627 0.41885 0.36338 0.41885 0.02729 0 0.05384-0.0034 0.07943-0.0099v0.6728h-0.411v0.28622h6.6087v-0.28622h-0.4111v-0.67288c0.02562 0.0066 0.05222 0.01005 0.07954 0.01005 0.20078 0 0.36338-0.18743 0.36338-0.41885 0-0.12881-0.0503-0.24411-0.12968-0.32095 0.0793-0.07685 0.12968-0.19215 0.12968-0.32095 0-0.19698-0.11783-0.36206-0.27669-0.40694-0.02544-0.15831-0.14566-0.27825-0.29018-0.27825-0.14463 0-0.26502 0.11994-0.29019 0.27814-0.15877 0.04488-0.27686 0.20996-0.27686 0.40706 0 0.12881 0.05059 0.24411 0.12994 0.32095-0.07939 0.07685-0.12994 0.19215-0.12994 0.32095 0 0.23142 0.1627 0.41885 0.36338 0.41885 0.02732 0 0.05383-0.0034 0.07936-0.0099v0.6728h-0.8225v-6.3745l-0.97824-0.2748-1.232 0.91141v1.0911zm-0.53489 4.6468v-4.4412l-0.65172 0.48201v3.9591h0.65172zm1.8172 0v-6.3413l-0.0055-0.0016-1.0287 0.76098v5.582h1.0341z",
    fillRule: "evenodd",
    strokeWidth: 0.0017812
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.75656 0 0 .65608 30.663 23.775)"
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 91.28,
    y: 2.3776,
    width: 38.635,
    height: 40.472,
    rx: 1.3989,
    ry: 1.6131,
    fill: "#ff8c00",
    fillOpacity: 0.1,
    stroke: "#ff8c00",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.27554
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3d4193"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 119.77,
    y: 18.285,
    width: 8.7429,
    height: 3.6295,
    rx: 2.0983,
    ry: 2.4197
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.91,
    y: 18.285,
    width: 8.7429,
    height: 3.6295,
    rx: 2.0983,
    ry: 2.4197
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.062,
    y: 18.285,
    width: 15.737,
    height: 3.6295,
    rx: 2.0983,
    ry: 2.4197
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.77,
    y: 22.721,
    width: 8.7429,
    height: 3.6295,
    rx: 2.0983,
    ry: 2.4197,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.91,
    y: 22.721,
    width: 8.7429,
    height: 3.6295,
    rx: 2.0983,
    ry: 2.4197,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.062,
    y: 22.721,
    width: 15.737,
    height: 3.6295,
    rx: 2.0983,
    ry: 2.4197,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.77,
    y: 27.157,
    width: 8.7429,
    height: 3.6295,
    rx: 2.0983,
    ry: 2.4197,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.91,
    y: 27.157,
    width: 8.7429,
    height: 3.6295,
    rx: 2.0983,
    ry: 2.4197,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.062,
    y: 27.157,
    width: 15.737,
    height: 3.6295,
    rx: 2.0983,
    ry: 2.4197,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.77,
    y: 31.593,
    width: 8.7429,
    height: 3.6295,
    rx: 2.0983,
    ry: 2.4197,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.91,
    y: 31.593,
    width: 8.7429,
    height: 3.6295,
    rx: 2.0983,
    ry: 2.4197,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.062,
    y: 31.593,
    width: 15.737,
    height: 3.6295,
    rx: 2.0983,
    ry: 2.4197,
    opacity: 0.75
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#ff8c00"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 119.77,
    y: 36.029,
    width: 8.7429,
    height: 3.6295,
    rx: 2.0983,
    ry: 2.4197
  })), /*#__PURE__*/React.createElement("g", {
    fontFamily: "Jamrul",
    strokeLinecap: "square",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("text", {
    transform: "scale(.93123 1.0738)",
    x: 100.12291,
    y: 9.8134842,
    fontSize: "6.7598px",
    strokeDasharray: "0.294209, 0.588419, 0.294209, 1.17683",
    strokeWidth: 0.29421,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 100.12291,
    y: 9.8134842,
    fill: "#ff8c00",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "6.7598px",
    strokeWidth: 0.29421
  }, "SBC Inc."))), /*#__PURE__*/React.createElement("text", {
    x: 93.307892,
    y: 16.553423,
    fontSize: "4.8821px",
    strokeDasharray: "0.207281, 0.414562, 0.207281, 0.829119",
    strokeWidth: 0.20728,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 93.307892,
    y: 16.553423,
    fill: "#ff8c00",
    fontFamily: "'Nunito Sans'",
    fontSize: "4.8821px",
    strokeWidth: 0.20728
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'Nunito Sans 10pt'"
  }, "Projects"), ":"))), /*#__PURE__*/React.createElement("text", {
    x: 93.668785,
    y: 39.087029,
    fontSize: "3.286px",
    strokeDasharray: "0.207281, 0.414562, 0.207281, 0.829119",
    strokeWidth: 0.20728,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 93.668785,
    y: 39.087029,
    fill: "#ff8c00",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.286px",
    strokeWidth: 0.20728
  }, "Total")))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.75656 0 0 .65608 -20.796 50.51)"
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 91.235,
    y: 4.1598,
    width: 38.635,
    height: 22.325,
    rx: 1.3989,
    ry: 1.6131,
    fill: "#ff8c00",
    fillOpacity: 0.1,
    stroke: "#ff8c00",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.27554
  })), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.93123 1.0738)",
    x: 100.30715,
    y: 22.081015,
    fill: "#0070e0",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.286px",
    opacity: 0.75,
    strokeMiterlimit: 10,
    strokeWidth: 0,
    textDecoration: "underline",
    style: {
      lineHeight: 0,
      textDecorationColor: "#0070e0",
      textDecorationLine: "underline"
    },
    xmlSpace: "preserve"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 100.30715,
    y: 22.081015,
    fill: "#0070e0",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.286px",
    strokeWidth: 0
  }, "View More"))), /*#__PURE__*/React.createElement("g", {
    fill: "#ff8c00"
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 119.46,
    y: 15.767,
    width: 8.3932,
    height: 3.6295,
    rx: 2.0983,
    ry: 2.4197
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 93.136,
    y: 15.767,
    width: 24.48,
    height: 3.6295,
    rx: 2.0983,
    ry: 2.4197
  })), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.93123 1.0738)",
    x: 99.99939,
    y: 11.991571,
    fontFamily: "Jamrul",
    fontSize: "6.7598px",
    strokeDasharray: "0.294209, 0.588419, 0.294209, 1.17683",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.29421,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 99.99939,
    y: 11.991571,
    fill: "#ff8c00",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "6.7598px",
    strokeWidth: 0.29421
  }, "SBC Inc."))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.75656 0 0 .65608 -61.386 26.938)"
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    transform: "translate(1.1532e-6)",
    x: 91.28,
    y: 2.3776,
    width: 38.635,
    height: 50.006,
    rx: 1.3989,
    ry: 1.6131,
    fill: "#ff8c00",
    fillOpacity: 0.1,
    stroke: "#ff8c00",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.27554
  })), /*#__PURE__*/React.createElement("g", null, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    transform: "translate(1.1532e-6)",
    x: 101.92,
    y: 45.035,
    width: 17.348,
    height: 5.4374,
    rx: 2.0983,
    ry: 2.4197,
    fill: "#ff8c00"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.93123 1.0738)",
    x: 114.56589,
    y: 45.84584,
    fill: "#ffffff",
    fontFamily: "Jamrul",
    fontSize: "3.9432px",
    strokeDasharray: "0.294209, 0.588419, 0.294209, 1.17683",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.29421,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 114.56589,
    y: 45.84584,
    fill: "#ffffff",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.9432px",
    strokeWidth: 0.29421
  }, "Save"))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 93.932,
    y: 23.549,
    width: 31.155,
    height: 3.7912,
    rx: 2.0983,
    ry: 2.4197,
    fill: "#ff8c00"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 92.718,
    y: 22.376,
    width: 35.759,
    height: 6.1379,
    rx: 1.0583,
    ry: 1.0583,
    fill: "none",
    stroke: "#ff8c00",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.19412
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 93.932,
    y: 31.134,
    width: 31.155,
    height: 3.7912,
    rx: 2.0983,
    ry: 2.4197,
    fill: "#ff8c00"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 92.718,
    y: 29.961,
    width: 35.759,
    height: 6.1379,
    rx: 1.0583,
    ry: 1.0583,
    fill: "none",
    stroke: "#ff8c00",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.19412
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 93.932,
    y: 38.72,
    width: 31.155,
    height: 3.7912,
    rx: 2.0983,
    ry: 2.4197,
    fill: "#ff8c00"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 92.718,
    y: 37.547,
    width: 35.759,
    height: 6.1379,
    rx: 1.0583,
    ry: 1.0583,
    fill: "none",
    stroke: "#ff8c00",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.19412
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 93.898,
    y: 15.964,
    width: 31.155,
    height: 3.7912,
    rx: 2.0983,
    ry: 2.4197,
    fill: "#ff8c00"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    strokeMiterlimit: 10
  }, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 92.683,
    y: 14.791,
    width: 35.759,
    height: 6.1379,
    rx: 1.0583,
    ry: 1.0583,
    fill: "none",
    stroke: "#ff8c00",
    strokeWidth: 0.19412
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 92.683,
    y: 5.2525,
    width: 35.856,
    height: 8.1662,
    rx: 1.0583,
    ry: 1.0583,
    fill: "none",
    stroke: "#ff8c00",
    strokeWidth: 0.19412
  })), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.93123 1.0738)",
    x: 101.44323,
    y: 11.151827,
    fill: "#ff8c00",
    fontFamily: "Jamrul",
    fontSize: "6.7598px",
    strokeDasharray: "0.294209, 0.588419, 0.294209, 1.17683",
    strokeWidth: 0.29421,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 101.44323,
    y: 11.151827,
    fill: "#ff8c00",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "6.7598px",
    strokeWidth: 0.29421
  }, "SBC Inc.")))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#4d4d4d",
    strokeMiterlimit: 10,
    strokeWidth: 0.52917
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.256 14.344c-10.375-6.0639-37.777 1.0192-30.957 10.895",
    markerEnd: "url(#ArrowWide)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.419 33.942c3.5286 12.697-11.758 4.6699-7.3572 16.756",
    markerEnd: "url(#ArrowWide-9)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.426 13.06c6.7924-5.8988 25.573-1.3968 26.798 10.256",
    markerEnd: "url(#ArrowWide-9-6)",
    opacity: 0.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyForms);
export default __webpack_public_path__ + "static/media/company-forms.3dbf7f2a97809f8e37a31b4f72f7688d.svg";
export { ForwardRef as ReactComponent };